import {createContext} from 'react';

export const UserGridContext = createContext({});
